/**
 * The Abstract class for all Base Auditing Model objects
 */
export class BaseAuditingModel {
    public createdBy: number;
    public createdDateTime: Date;
    public modifiedBy: number;
    public modifiedDateTime: Date;
}
